// extracted by mini-css-extract-plugin
module.exports = {"imageLightBox":"LightBoxComponent__imageLightBox__TBiLN","prev":"LightBoxComponent__prev__3juRL","next":"LightBoxComponent__next__27XZn"};